{
  "close": "Închideţi",
  "notifications": "Notificări"
}
